export default __webpack_public_path__ + "static/media/project_cover.653c1148.webp";